import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import BackToTop from "../../components/ui/BackToTop";
import SiteFooter from "../../components/ui/SiteFooter";
import SiteHeader from "../../components/ui/SiteHeader";
import type { NavLink } from "../../shared/types/navigation";

type MainLayoutProps = {
  navLinks?: NavLink[];
  children: ReactNode;
};

function MainLayout({ navLinks = [], children }: MainLayoutProps) {
  const location = useLocation();
  const isProfilePage = location.pathname === "/profile";

  return (
    <div className="min-h-screen bg-white">
      <SiteHeader navLinks={navLinks} />
      <main className={isProfilePage ? "pt-0" : "pt-14 md:pt-0"}>
        {children}
      </main>
      <SiteFooter navLinks={navLinks} />
      <BackToTop isProfile={isProfilePage} />
    </div>
  );
}

export default MainLayout;
